import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import TabModuleHead from '@src/pc/index/components/TabModuleHead';
import BattleChart from '@src/pc/components/BattleChart';
import Group from './Group';
import Chip from 'Chip';

const Integral = ({ tabNameHead, group, knockout }) => {
    const [tabContent, setTabContent] = useState([
        {
            name: tabNameHead.name2,
            active: true,
        },
        {
            name: tabNameHead.name1,
            active: false,
        },
    ]);
    const adContent = {
        adPic: tabNameHead.adPic,
        adUrl: tabNameHead.adUrl,
    };

    const changeTabContent = (value) => {
        setTabContent(value);
    };

    return (
        <div className={styles.integral}>
            <Chip id="260485" type="struct" title="tab名称切换头">
                <TabModuleHead tabContent={tabContent} changeTabContent={changeTabContent} adContent={adContent} />
            </Chip>
            {tabContent[0].active && <BattleChart content={knockout} />}
            {tabContent[1].active && <Group content={group} />}
        </div>
    );
};

Integral.propTypes = {
    tabNameHead: PropTypes.object,
    group: PropTypes.object,
    knockout: PropTypes.object,
};

export default errorBoundary(Integral);
